/* =========================================================
	GALLERY SCRIPT(S)
========================================================= */
import UIkit from 'uikit';
